// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React from "react";
import styled from "styled-components";

const Container = styled.h4`
  font-weight: bold;
`;

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'children' implicitly has an 'any' type.
function Title({ children }) {
  return <Container>{children}</Container>;
}

export { Title };
